import React from "react";
import "../styles/ServiceCards.css";

const ServiceCards = () => {
    const services = [
        {
            title: "Data Analytics and visualizations",
            description: "Transforming raw data into actionable insights to help businesses make informed decisions.",
        },
        {
            title: "Predictive Modeling",
            description: "Utilizing machine learning and statistical techniques to forecast future trends and behaviors.",
        },
        {
            title: "Business Insights",
            description: "Providing tailored solutions to identify opportunities and optimize business performance.",
        },
        {
            title: "Program Evaluation",
            description: "Our comprehensive program evaluation services will help you assess your initiatives, improve performance, and demonstrate results to stakeholders."
        }
    ];

    return (
        <section className="services">
            <h2 className="services-title">Our Services</h2>
            <div className="services-container">
                {services.map((service, index) => (
                    <div key={index} className="service-card">
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ServiceCards;